import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const InfoBox = ({ children, className, hasDiscount, show }) => {
  const theme = useContext(ThemeContext);

  if (!show) {
    return null;
  }

  return (
    <>
      <div className={classNames('info-box', `info-box--info`, className)}>
        <div className="info-box__content">{children}</div>
        <FontAwesomeIcon
          icon={faExclamationCircle}
          style={{ height: 18, width: 18 }}
        />
      </div>
      <style jsx>{`
        .info-box {
          position: relative;
          display: flex;
          align-items: center;
          padding: 8px;
          display: flex;
          margin-bottom: 8px;
          width: 40%;
          margin-left: auto;
        }
        .info-box--info {
          color: #2c90e9;
          border: 1px solid #2c90e9;
          background-color: #eaf4fd;
        }
        .info-box:after {
          content: '';
          width: 12px;
          height: 12px;
          border-width: 0 1px 1px 0;
          border-style: solid;
          position: absolute;
          bottom: -7px;
          z-index: 1;
          transform: rotate(45deg);
          left: calc(40% - 6px);
        }
        .info-box--info:after {
          background-color: #eaf4fd;
          border-color: #2c90e9;
        }
        .info-box__content {
          flex-grow: 1;
          margin-right: 12px;
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .info-box {
            width: 50%;
          }
          .info-box:after {
            left: calc(40% - 6px);
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .info-box {
            width: 100%;
          }
          .info-box:after {
            left: ${hasDiscount ? 'calc(50% - 6px)' : 'calc(25% - 6px)'};
          }
        }
      `}</style>
    </>
  );
};

InfoBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hasDiscount: PropTypes.bool,
  show: PropTypes.bool,
};

export default InfoBox;
